import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// REQUEST INTERCEPTOR: Sætter token på alle udgående kald
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); // Hent fra local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Sæt headeren
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;